<div class="container-fluid border rounded bg-light mt-4 p-3">
  <h4 class="mb-2">{{client.fullName}}</h4>
  <div class="row">
    @if (client.logoUrl) {
      <div class="col-1 mr-4">
        <a href="#" (click)="onLogoClick($event)">
          <img alt="client logo"
            [src]="client.logoUrl"
            class="img-fluid"
            style="max-height: 100px;" />
        </a>
      </div>
    }
    <div class="col">
      <div class="d-flex gap-4 mb-4">
        <div>
          <small class="text-muted text-uppercase">Client ID</small>
          <div>{{client.claimIdentifierPrefix}}</div>
        </div>
        <div>
          <small class="text-muted text-uppercase">Entity Type</small>
          <div>{{client.entityTypes.join(", ")}}</div>
        </div>
        <div>
          <small class="text-muted text-uppercase">Program Go-Live Date</small>
          <div>{{client.goLiveDate}}</div>
        </div>
      </div>
      <div class="mb-4">
        <small class="text-muted text-uppercase">HRSA IDs</small>
        <div class="mt-1">
          @for (hrsa of client.hrsaIdStrings; track hrsa) {
            <span class="badge bg-secondary-subtle text-dark fw-normal fs-6 me-1">{{ hrsa }}</span>
          }
        </div>
      </div>
      <div>
        <small class="text-muted text-uppercase">Live TPAs</small>
        <div class="mt-1">
          @for (tpa of recentlyActiveTpas; track tpa) {
            <span class="badge bg-warning-subtle text-danger-emphasis fw-normal fs-6 me-1">{{ tpa }}</span>
          } @empty {
            --
          }
        </div>
      </div>
    </div>
  </div>
</div>
